import axios from "axios";
import { uploadImage } from "services/firebase";
const {
  LOGIN,
  GET_USERS,
  BASE_URL,
  API_URL,
  GET_USER_DETAIL,
  UPDATE_USER_DETAIL,
  GET_PROJECTS,
  GET_PROJECT_DETAIL,
  GET_GRAPH_DETAIL,
  EDIT_PROJECT,
  GET_LEADERBOARD,
  CREATE_COMPETITION,
  END_COMPETITION,
  VERIFY_PROJECT,
  GET_VERIFICATIONS_LIST,
  GET_PREVIOUS_LEADERBOARD,
  GET_PREVIOUS_LEADERBOARD_DATA,
  EDIT_LEADERBOARD_DESCRIPTION,
  DELETE_USER,
  DELETE_PROJECT,
  GET_STREAKS,
  GET_BADGES,
  GET_STREAK_MILESTONE_DETAILS,
  ADD_STREAK_MILESTONE,
  EDIT_STREAK_MILESTONE,
  GET_BADGES_DEFINITIONS,
  GET_BADGE_DEFINITION_DETAILS,
  CREATE_BADGE_DEFINITION,
  UPDATE_BADGE_DEFINITION,
  DELETE_BADGE_DEFINITION,
  GET_LEVELS,
  CREATE_LEVEL,
  UPDATE_LEVEL,
  DELETE_LEVEL,
  GET_TIERS,
  GET_LEVEL_DETAILS,
  GET_TIER_DETAILS,
  CREATE_TIER,
  UPDATE_TIER,
  DELETE_TIER,
  GET_STREAK_GLOBAL_SETTINGS,
  GET_CONFIGS,
  DELETE_STREAK_MILESTONE,
  UPDATE_STREAK_GLOBAL_SETTINGS,
  GET_CONFIG_DETAILS,
  UPDATE_CONFIGS,
  DELETE_CONFIGS,
  GET_USER_REWARDS,
  ISSUE_USER_REWARD,
  GET_REWARDS,
  CREATE_REWARD,
  UPDATE_REWARD,
  DELETE_REWARD,
  GET_MILESTONE_REVIEW_REQUESTS,
  REVIEW_MILESTONE_REQUESTS,
} = require("./apiConstants");

var authorizationToken = localStorage.getItem("token");
// logMessage(authorizationToken);
const axiosInstance = axios.create({
  baseURL: BASE_URL,
  timeout: 20000,
  headers: {
    api_key: API_URL,
  },
});

const axiosInstanceAfterLogin = axios.create({
  baseURL: BASE_URL,
  timeout: 20000,
  headers: {
    api_key: API_URL,
    authorization: localStorage.getItem("loginData")
      ? JSON.parse(localStorage.getItem("loginData")).token
      : "",
  },
});

const api = {
  login: async (userData) => {
    try {
      const response = await axiosInstance.post(LOGIN, userData);
      if (response.status !== 200) {
        const errorMessage = `Error: ${response.statusText} (${response.status})`;
        alert(errorMessage);
        throw new Error(errorMessage);
      }
      return response.data;
    } catch (error) {
      alert(error);
      console.error("Error fetching users:", error);
      throw error; // Rethrow error to handle in components
    }
  },
  updateUserDetail: async (userData) => {
    try {
      const response = await axiosInstanceAfterLogin.post(UPDATE_USER_DETAIL, userData);
      if (response.status !== 200) {
        const errorMessage = `Error: ${response.statusText} (${response.status})`;
        alert(errorMessage);
        throw new Error(errorMessage);
      }
      return response.data;
    } catch (error) {
      alert(error);
      console.error("Error fetching users:", error);
      throw error; // Rethrow error to handle in components
    }
  },
  getUserDetail: async (userData) => {
    try {
      const response = await axiosInstanceAfterLogin.post(GET_USER_DETAIL, userData);
      if (response.status !== 200) {
        const errorMessage = `Error: ${response.statusText} (${response.status})`;
        alert(errorMessage);
        throw new Error(errorMessage);
      }
      return response.data;
    } catch (error) {
      alert(error);
      console.error("Error fetching users:", error);
      throw error; // Rethrow error to handle in components
    }
  },
  getUsersList: async (filterData) => {
    try {
      const response = await axiosInstanceAfterLogin.post(GET_USERS, filterData);
      if (response.status !== 200) {
        const errorMessage = `Error: ${response.statusText} (${response.status})`;
        alert(errorMessage);
        throw new Error(errorMessage);
      }
      return response.data;
    } catch (error) {
      alert(error);
      console.error("Error fetching users:", error);
      throw error; // Rethrow error to handle in components
    }
  },
  getProjectsList: async (filterData) => {
    try {
      const response = await axiosInstanceAfterLogin.post(GET_PROJECTS, filterData);
      if (response.status !== 200) {
        const errorMessage = `Error: ${response.statusText} (${response.status})`;
        alert(errorMessage);
        throw new Error(errorMessage);
      }
      return response.data;
    } catch (error) {
      alert(error);
      console.error("Error fetching users:", error);
      throw error; // Rethrow error to handle in components
    }
  },
  getVerificationsList: async (filterData) => {
    try {
      const response = await axiosInstanceAfterLogin.post(GET_VERIFICATIONS_LIST, filterData);
      if (response.status !== 200) {
        const errorMessage = `Error: ${response.statusText} (${response.status})`;
        alert(errorMessage);
        throw new Error(errorMessage);
      }
      return response.data;
    } catch (error) {
      alert(error);
      console.error("Error fetching verifications:", error);
      throw error;
    }
  },
  getStreaksList: async (filterData) => {
    try {
      const response = await axiosInstanceAfterLogin.post(GET_STREAKS, filterData);
      if (response.status !== 200) {
        const errorMessage = `Error: ${response.statusText} (${response.status})`;
        alert(errorMessage);
        throw new Error(errorMessage);
      }
      return response.data;
    } catch (error) {
      alert(error);
      console.error("Error fetching users:", error);
      throw error; // Rethrow error to handle in components
    }
  },
  getStreakMilestoneDetails: async (filterData) => {
    try {
      const response = await axiosInstanceAfterLogin.post(GET_STREAK_MILESTONE_DETAILS, filterData);
      if (response.status !== 200) {
        const errorMessage = `Error: ${response.statusText} (${response.status})`;
        alert(errorMessage);
        throw new Error(errorMessage);
      }
      return response.data;
    } catch (error) {
      alert(error);
      console.error("Error fetching streak milestone details:", error);
      throw error; 
    }
  },
  getBadges: async (filterData) => {
    try {
      const response = await axiosInstanceAfterLogin.post(GET_BADGES, filterData);
      if (response.status !== 200) {
        const errorMessage = `Error: ${response.statusText} (${response.status})`;
        alert(errorMessage);
        throw new Error(errorMessage);
      }
      return response.data;
    } catch (error) {
      alert(error);
      console.error("Error fetching badges:", error);
      throw error; 
    }
  },
  getBadgeDefinitions: async (filterData) => {
    try {
      const response = await axiosInstanceAfterLogin.post(GET_BADGES_DEFINITIONS, filterData);
      if (response.status !== 200) {
        const errorMessage = `Error: ${response.statusText} (${response.status})`;
        alert(errorMessage);
        throw new Error(errorMessage);
      }
      return response.data;
    } catch (error) {
      alert(error);
      console.error("Error fetching badges:", error);
      throw error; 
    }
  },
  getLevels: async (filterData) => {
    try {
      const response = await axiosInstanceAfterLogin.post(GET_LEVELS, filterData);
      if (response.status !== 200) {
        const errorMessage = `Error: ${response.statusText} (${response.status})`;
        alert(errorMessage);
        throw new Error(errorMessage);
      }
      return response.data;
    } catch (error) {
      alert(error);
      console.error("Error fetching levels:", error);
      throw error; 
    }
  },
  getLevelDetails: async (filterData) => {
    try {
      const response = await axiosInstanceAfterLogin.post(GET_LEVEL_DETAILS, filterData);
      if (response.status !== 200) {
        const errorMessage = `Error: ${response.statusText} (${response.status})`;
        alert(errorMessage);
        throw new Error(errorMessage);
      }
      return response.data;
    } catch (error) {
      alert(error);
      console.error("Error fetching level details:", error);
      throw error; 
    }
  },
  getTiers: async (filterData) => {
    try {
      const response = await axiosInstanceAfterLogin.post(GET_TIERS, filterData);
      if (response.status !== 200) {
        const errorMessage = `Error: ${response.statusText} (${response.status})`;
        alert(errorMessage);
        throw new Error(errorMessage);
      }
      return response.data;
    } catch (error) {
      alert(error);
      console.error("Error fetching tiers:", error);
      throw error; 
    }
  },
  getTierDetails: async (filterData) => {
    try {
      const response = await axiosInstanceAfterLogin.post(GET_TIER_DETAILS, filterData);
      if (response.status !== 200) {
        const errorMessage = `Error: ${response.statusText} (${response.status})`;
        alert(errorMessage);
        throw new Error(errorMessage);
      }
      return response.data;
    } catch (error) {
      alert(error);
      console.error("Error fetching tiers:", error);
      throw error; 
    }
  },
  getStreakGlobalSettings: async (filterData) => {
    try {
      const response = await axiosInstanceAfterLogin.post(GET_STREAK_GLOBAL_SETTINGS, filterData);
      if (response.status !== 200) {
        const errorMessage = `Error: ${response.statusText} (${response.status})`;
        alert(errorMessage);
        throw new Error(errorMessage);
      }
      return response.data;
    } catch (error) {
      alert(error);
      console.error("Error fetching streak global settings:", error);
      throw error; 
    }
  },
  getGamificationConfigs: async (filterData) => {
    try {
      const response = await axiosInstanceAfterLogin.post(GET_CONFIGS, filterData);
      if (response.status !== 200) {
        const errorMessage = `Error: ${response.statusText} (${response.status})`;
        alert(errorMessage);
        throw new Error(errorMessage);
      }
      return response.data;
    } catch (error) {
      alert(error);
      console.error("Error fetching gamification configs:", error);
      throw error; 
    }
  },
  getGamificationConfigDetails: async (filterData) => {
    try {
      const response = await axiosInstanceAfterLogin.post(GET_CONFIG_DETAILS, filterData);
      if (response.status !== 200) {
        const errorMessage = `Error: ${response.statusText} (${response.status})`;
        alert(errorMessage);
        throw new Error(errorMessage);
      }
      return response.data;
    } catch (error) {
      alert(error);
      console.error("Error fetching badge definition details:", error);
      throw error; 
    }
  },
  getBadgeDefinitionDetails: async (filterData) => {
    try {
      const response = await axiosInstanceAfterLogin.post(GET_BADGE_DEFINITION_DETAILS, filterData);
      if (response.status !== 200) {
        const errorMessage = `Error: ${response.statusText} (${response.status})`;
        alert(errorMessage);
        throw new Error(errorMessage);
      }
      return response.data;
    } catch (error) {
      alert(error);
      console.error("Error fetching badge definition details:", error);
      throw error; 
    }
  },
  getProjectsDetail: async (filterData) => {
    try {
      const response = await axiosInstanceAfterLogin.post(GET_PROJECT_DETAIL, filterData);
      if (response.status !== 200) {
        const errorMessage = `Error: ${response.statusText} (${response.status})`;
        alert(errorMessage);
        throw new Error(errorMessage);
      }
      return response.data;
    } catch (error) {
      alert(error);
      console.error("Error fetching users:", error);
      throw error; // Rethrow error to handle in components
    }
  },
  getGraphDetail: async () => {
    try {
      const response = await axiosInstanceAfterLogin.post(GET_GRAPH_DETAIL);
      if (response.status !== 200) {
        const errorMessage = `Error: ${response.statusText} (${response.status})`;
        alert(errorMessage);
        throw new Error(errorMessage);
      }
      return response.data;
    } catch (error) {
      alert(error);
      console.error("Error fetching users:", error);
      throw error; // Rethrow error to handle in components
    }
  },
  getRewards: async (data) => {
    try {
      const response = await axiosInstanceAfterLogin.post(GET_REWARDS);
      if (response.status !== 200) {
        const errorMessage = `Error: ${response.statusText} (${response.status})`;
        alert(errorMessage);
        throw new Error(errorMessage);
      }
      return response.data;
    } catch (error) {
      alert(error);
      console.error("Error fetching rewards:", error);
      throw error; // Rethrow error to handle in components
    }
  },
  createReward: async (data) => {
    try {
      const response = await axiosInstanceAfterLogin.post(CREATE_REWARD, data);
      if (response.status !== 200) {
        const errorMessage = `Error: ${response.statusText} (${response.status})`;
        alert(errorMessage);
        throw new Error(errorMessage);
      }
      return response.data;
    } catch (error) {
      alert(error);
      console.error("Error creating reward:", error);
      throw error; // Rethrow error to handle in components
    }
  },
  updateReward: async (data) => {
    try {
      const response = await axiosInstanceAfterLogin.post(UPDATE_REWARD, data);
      if (response.status !== 200) {
        const errorMessage = `Error: ${response.statusText} (${response.status})`;
        alert(errorMessage);
        throw new Error(errorMessage);
      }
      return response.data;
    } catch (error) {
      alert(error);
      console.error("Error update reward:", error);
      throw error; // Rethrow error to handle in components
    }
  },
  deleteReward: async (data) => {
    try {
      const response = await axiosInstanceAfterLogin.post(DELETE_REWARD, data);
      if (response.status !== 200) {
        const errorMessage = `Error: ${response.statusText} (${response.status})`;
        throw new Error(errorMessage);
      }
      return response.data;
    } catch (error) {
      console.error("Error deleting reward:", error);
      throw error;
    }
  },
  getUserRewards: async (data) => {
    try {
      const response = await axiosInstanceAfterLogin.post(GET_USER_REWARDS, data);
      if (response.status !== 200) {
        const errorMessage = `Error: ${response.statusText} (${response.status})`;
        alert(errorMessage);
        throw new Error(errorMessage);
      }
      return response.data;
    } catch (error) {
      alert(error);
      console.error("Error fetching users:", error);
      throw error; // Rethrow error to handle in components
    }
  },
  issueReward: async (data) => {
    try {
      const response = await axiosInstanceAfterLogin.post(ISSUE_USER_REWARD, data);
      if (response.status !== 200) {
        const errorMessage = `Error: ${response.statusText} (${response.status})`;
        alert(errorMessage);
        throw new Error(errorMessage);
      }
      return response.data;
    } catch (error) {
      alert(error);
      console.error("Error fetching users:", error);
      throw error; // Rethrow error to handle in components
    }
  },
  getReviewMilstoneRequest: async (data) => {
    try {
      const response = await axiosInstanceAfterLogin.post(GET_MILESTONE_REVIEW_REQUESTS, data);
      if (response.status !== 200) {
        const errorMessage = `Error: ${response.statusText} (${response.status})`;
        alert(errorMessage);
        throw new Error(errorMessage);
      }
      return response.data;
    } catch (error) {
      alert(error);
      console.error("Error fetching milestone requests:", error);
      throw error; // Rethrow error to handle in components
    }
  },
  reviewMilestoneRequest: async (data) => {
    try {
      const response = await axiosInstanceAfterLogin.post(REVIEW_MILESTONE_REQUESTS, data);
      if (response.status !== 200) {
        const errorMessage = `Error: ${response.statusText} (${response.status})`;
        alert(errorMessage);
        throw new Error(errorMessage);
      }
      return response.data;
    } catch (error) {
      alert(error);
      console.error("Error while review milestone request:", error);
      throw error; // Rethrow error to handle in components
    }
  },
  editProject: async (projectData) => {
    try {
      let dataToSubmit = { ...projectData };

      // Only process images if they exist in the project data
      if (projectData.image) {
        const uploadImageUrls = [];
        for (const image of projectData.image) {
          if (image instanceof File) {
            const uploadImageUrl = await uploadImage(image, "project");
            uploadImageUrls.push(uploadImageUrl);
          } else {
            uploadImageUrls.push(image);
          }
        }
        dataToSubmit.image = JSON.stringify(uploadImageUrls);
      }

      // Only stringify tags if they exist
      if (projectData.tags) {
        dataToSubmit.tags = JSON.stringify(projectData.tags);
      }

      const response = await axiosInstanceAfterLogin.post(EDIT_PROJECT, dataToSubmit);
      if (response.status !== 200) {
        const errorMessage = `Error: ${response.statusText} (${response.status})`;
        throw new Error(errorMessage);
      }
      return response.data;
    } catch (error) {
      console.error("Error editing project:", error);
      throw error;
    }
  },
  addStreakMilestone: async (data) => {
    try {
      const response = await axiosInstanceAfterLogin.post(ADD_STREAK_MILESTONE, data);
      if (response.status !== 200) {
        const errorMessage = `Error: ${response.statusText} (${response.status})`;
        throw new Error(errorMessage);
      }
      return response.data;
    } catch (error) {
      console.error("Error adding streak milestone:", error);
      throw error;
    }
  },
  editStreakMilestone: async (data) => {
    try {
      const response = await axiosInstanceAfterLogin.post(EDIT_STREAK_MILESTONE, data);
      if (response.status !== 200) {
        const errorMessage = `Error: ${response.statusText} (${response.status})`;
        throw new Error(errorMessage);
      }
      return response.data;
    } catch (error) {
      console.error("Error editing streak milestone:", error);
      throw error;
    }
  },
  deleteStreakMilestone: async (data) => {
    try {
      const response = await axiosInstanceAfterLogin.post(DELETE_STREAK_MILESTONE, data);
      if (response.status !== 200) {
        const errorMessage = `Error: ${response.statusText} (${response.status})`;
        throw new Error(errorMessage);
      }
      return response.data;
    } catch (error) {
      console.error("Error deleting streak milestone:", error);
      throw error;
    }
  },
  createBadgeDefinition: async (data) => {
    try {
      const response = await axiosInstanceAfterLogin.post(CREATE_BADGE_DEFINITION, data);
      if (response.status !== 200) {
        const errorMessage = `Error: ${response.statusText} (${response.status})`;
        throw new Error(errorMessage);
      }
      return response.data;
    } catch (error) {
      console.error("Error adding badge definition:", error);
      throw error;
    }
  },
  updateBadgeDefinition: async (data) => {
    try {
      const response = await axiosInstanceAfterLogin.post(UPDATE_BADGE_DEFINITION, data);
      if (response.status !== 200) {
        const errorMessage = `Error: ${response.statusText} (${response.status})`;
        throw new Error(errorMessage);
      }
      return response.data;
    } catch (error) {
      console.error("Error updating badge definition:", error);
      throw error;
    }
  },
  updateStreakGlobalSettings: async (data) => {
    try {
      const response = await axiosInstanceAfterLogin.post(UPDATE_STREAK_GLOBAL_SETTINGS, data);
      if (response.status !== 200) {
        const errorMessage = `Error: ${response.statusText} (${response.status})`;
        throw new Error(errorMessage);
      }
      return response.data;
    } catch (error) {
      console.error("Error updating streak global settings:", error);
      throw error;
    }
  }, 
  updateGamificationConfig: async (data) => {
    try {
      const response = await axiosInstanceAfterLogin.post(UPDATE_CONFIGS, data);
      if (response.status !== 200) {
        const errorMessage = `Error: ${response.statusText} (${response.status})`;
        throw new Error(errorMessage);
      }
      return response.data;
    } catch (error) {
      console.error("Error updating streak global settings:", error);
      throw error;
    }
  },
  deleteGamificationConfig: async (data) => {
    try {
      const response = await axiosInstanceAfterLogin.post(DELETE_CONFIGS, data);
      if (response.status !== 200) {
        const errorMessage = `Error: ${response.statusText} (${response.status})`;
        throw new Error(errorMessage);
      }
      return response.data;
    } catch (error) {
      console.error("Error deleting config:", error);
      throw error;
    }
  },
  deleteBadgeDefinition: async (data) => {
    try {
      const response = await axiosInstanceAfterLogin.post(DELETE_BADGE_DEFINITION, data);
      if (response.status !== 200) {
        const errorMessage = `Error: ${response.statusText} (${response.status})`;
        throw new Error(errorMessage);
      }
      return response.data;
    } catch (error) {
      console.error("Error deleting badge definition:", error);
      throw error;
    }
  },
  createLevel: async (data) => {
    try {
      const response = await axiosInstanceAfterLogin.post(CREATE_LEVEL, data);
      if (response.status !== 200) {
        const errorMessage = `Error: ${response.statusText} (${response.status})`;
        throw new Error(errorMessage);
      }
      return response.data;
    } catch (error) {
      console.error("Error creating new level:", error);
      throw error;
    }
  },
  updateLevel: async (data) => {
    try {
      const response = await axiosInstanceAfterLogin.post(UPDATE_LEVEL, data);
      if (response.status !== 200) {
        const errorMessage = `Error: ${response.statusText} (${response.status})`;
        throw new Error(errorMessage);
      }
      return response.data;
    } catch (error) {
      console.error("Error updating level:", error);
      throw error;
    }
  },
  deleteLevel: async (data) => {
    try {
      const response = await axiosInstanceAfterLogin.post(DELETE_LEVEL, data);
      if (response.status !== 200) {
        const errorMessage = `Error: ${response.statusText} (${response.status})`;
        throw new Error(errorMessage);
      }
      return response.data;
    } catch (error) {
      console.error("Error deleting level:", error);
      throw error;
    }
  },
  createTier: async (data) => {
    try {
      let dataToSubmit = { ...data };

      // Only process images if they exist in the project data
      if (data.icon) {
        const uploadImageUrl = await uploadImage(data.icon, "badges");
        dataToSubmit.icon = uploadImageUrl;
      }
      const response = await axiosInstanceAfterLogin.post(CREATE_TIER, dataToSubmit);
      if (response.status !== 200) {
        const errorMessage = `Error: ${response.statusText} (${response.status})`;
        throw new Error(errorMessage);
      }
      return response.data;
    } catch (error) {
      console.error("Error creating new tier:", error);
      throw error;
    }
  },
  updateTier: async (data) => {
    try {
      let dataToSubmit = { ...data };

      if (data.icon && typeof data.icon !== "string") {
        const uploadImageUrl = await uploadImage(data.icon, "badges");
        dataToSubmit.icon = uploadImageUrl;
      }

      if (!data.icon) {
        delete dataToSubmit.icon;
      }
      const response = await axiosInstanceAfterLogin.post(UPDATE_TIER, dataToSubmit);
      if (response.status !== 200) {
        const errorMessage = `Error: ${response.statusText} (${response.status})`;
        throw new Error(errorMessage);
      }
      return response.data;
    } catch (error) {
      console.error("Error updating tier:", error);
      throw error;
    }
  },
  deleteTier: async (data) => {
    try {
      const response = await axiosInstanceAfterLogin.post(DELETE_TIER, data);
      if (response.status !== 200) {
        const errorMessage = `Error: ${response.statusText} (${response.status})`;
        throw new Error(errorMessage);
      }
      return response.data;
    } catch (error) {
      console.error("Error deleting tier:", error);
      throw error;
    }
  },
  getLeaderboard: async (data) => {
    try {
      const response = await axiosInstanceAfterLogin.post(GET_LEADERBOARD, data);
      if (response.status !== 200) {
        const errorMessage = `Error: ${response.statusText} (${response.status})`;
        alert(errorMessage);
        throw new Error(errorMessage);
      }
      return response.data;
    } catch (error) {
      alert(error);
      console.error("Error fetching leaderboard:", error);
      throw error;
    }
  },
  getPreviousLeaderboard: async () => {
    try {
      const response = await axiosInstanceAfterLogin.post(GET_PREVIOUS_LEADERBOARD);
      if (response.status !== 200) {
        const errorMessage = `Error: ${response.statusText} (${response.status})`;
        alert(errorMessage);
        throw new Error(errorMessage);
      }
      return response.data;
    } catch (error) {
      alert(error);
      console.error("Error fetching previous leaderboards:", error);
      throw error;
    }
  },
  getPreviousLeaderboardData: async (data) => {
    try {
      const response = await axiosInstanceAfterLogin.post(GET_PREVIOUS_LEADERBOARD_DATA, data);
      if (response.status !== 200) {
        const errorMessage = `Error: ${response.statusText} (${response.status})`;
        alert(errorMessage);
        throw new Error(errorMessage);
      }
      return response.data;
    } catch (error) {
      alert(error);
      console.error("Error fetching previous leaderboard data:", error);
      throw error;
    }
  },
  createCompetition: async (action) => {
    try {
      const response = await axiosInstanceAfterLogin.post(CREATE_COMPETITION, { action });
      if (response.status !== 200) {
        const errorMessage = `Error: ${response.statusText} (${response.status})`;
        alert(errorMessage);
        throw new Error(errorMessage);
      }
      return response.data;
    } catch (error) {
      alert(error);
      console.error("Error managing competition:", error);
      throw error;
    }
  },
  endCompetition: async (action) => {
    try {
      const response = await axiosInstanceAfterLogin.post(END_COMPETITION, { action });
      if (response.status !== 200) {
        const errorMessage = `Error: ${response.statusText} (${response.status})`;
        alert(errorMessage);
        throw new Error(errorMessage);
      }
      return response.data;
    } catch (error) {
      alert(error);
      console.error("Error managing competition:", error);
      throw error;
    }
  },
  verifyProjectForLeaderboard: async (projectData) => {
    try {
      const response = await axiosInstanceAfterLogin.post(VERIFY_PROJECT, projectData);
      if (response.status !== 200) {
        const errorMessage = `Error: ${response.statusText} (${response.status})`;
        alert(errorMessage);
        throw new Error(errorMessage);
      }
      return response.data;
    } catch (error) {
      alert(error);
      console.error("Error verifying project for leaderboard:", error);
      throw error;
    }
  },
  deleteUser: async (data) => {
    try {
      const response = await axiosInstanceAfterLogin.post(DELETE_USER, data);
      if (response.status !== 200) {
        const errorMessage = `Error: ${response.statusText} (${response.status})`;
        alert(errorMessage);
        throw new Error(errorMessage);
      }
      return response.data;
    } catch (error) {
      alert(error);
      console.error("Error managing competition:", error);
      throw error;
    }
  },
  deleteProject: async (data) => {
    try {
      const response = await axiosInstanceAfterLogin.post(DELETE_PROJECT, data);
      if (response.status !== 200) {
        const errorMessage = `Error: ${response.statusText} (${response.status})`;
        alert(errorMessage);
        throw new Error(errorMessage);
      }
      return response.data;
    } catch (error) {
      alert(error);
      console.error("Error managing competition:", error);
      throw error;
    }
  },
  editLeaderboardDescription: async (data) => {
    try {
      const response = await axiosInstanceAfterLogin.post(EDIT_LEADERBOARD_DESCRIPTION, data);
      if (response.status !== 200) {
        const errorMessage = `Error: ${response.statusText} (${response.status})`;
        alert(errorMessage);
        throw new Error(errorMessage);
      }
      return response.data;
    } catch (error) {
      alert(error);
      console.error("Error editing leaderboard description:", error);
      throw error;
    }
  },
};

export default api;
